var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-4" }, [
        _c("div", { staticClass: "form-group" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.receiptList[0].buyerName || ""))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.receiptList[0].sellerName || ""))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.receiptList[0].buyerInnerSellerCode || ""))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.receiptList[0].prftCenterCode || ""))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.memo,
                  expression: "memo"
                }
              ],
              staticStyle: { width: "320px", height: "90px" },
              domProps: { value: _vm.memo },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.memo = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("验收单信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "fr font12" }, [
          _c("span", [
            _vm._v("结算金额：" + _vm._s(_vm.totalWtxAmount || 0.0) + "元")
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: { data: _vm.receiptList, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "recvBizUnitName",
                  label: "业务单元",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "recvBizUnitCode",
                  label: "门店编号",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "innerNo",
                  label: "验收单号",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "recvDate",
                  width: "160",
                  label: _vm.returnFalg ? "退货日期" : "验收日期"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "receiptQuantity",
                  width: "160",
                  label: "验收数量"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "wtxAmount",
                  width: "160",
                  label: "结算金额(元)"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ntxPrice", align: "left", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "swb-btn swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.viewPurchReceipt(rows.row.id)
                              }
                            }
                          },
                          [_vm._v("验收详情")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.phasedPaymentAllowed
        ? [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(7),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.settlePayPhaseInfo.acntPeriodForm,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.settlePayPhaseInfo,
                              "acntPeriodForm",
                              $$v
                            )
                          },
                          expression: "settlePayPhaseInfo.acntPeriodForm"
                        }
                      },
                      [
                        _vm.payPeriodTypesAllowed.indexOf(2) > -1
                          ? _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v("阶段间隔天数")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.payPeriodTypesAllowed.indexOf(1) > -1
                          ? _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("账期")
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "el-form",
              { ref: "ruleForm", attrs: { model: _vm.settlePayPhaseInfo } },
              [
                _c("table", { staticClass: "custom-tbl error-prompt" }, [
                  _c("thead", { staticClass: "head" }, [
                    _c("tr", { staticClass: "row" }, [
                      _c("th", { staticClass: "text-align: left; required" }, [
                        _vm._v("阶段名称")
                      ]),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-align: left; required",
                          attrs: { width: "200" }
                        },
                        [_vm._v("阶段类型")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-align: right; required",
                          attrs: { width: "200" }
                        },
                        [_vm._v("账期起算日")]
                      ),
                      _vm._v(" "),
                      _vm.settlePayPhaseInfo.acntPeriodForm == 1
                        ? _c(
                            "th",
                            {
                              staticClass: "text-align: right; required",
                              attrs: { width: "100" }
                            },
                            [_vm._v("账期(天)")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.settlePayPhaseInfo.acntPeriodForm == 2
                        ? _c(
                            "th",
                            {
                              staticClass: "text-align: right; required",
                              attrs: { width: "140" }
                            },
                            [_vm._v("当期阶段间隔天数")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-align: left; required",
                          attrs: { width: "200" }
                        },
                        [_vm._v("金额计算依据")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-align: left; required",
                          attrs: { width: "120" }
                        },
                        [_vm._v("付款比例(%)")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-align: left;",
                          attrs: { width: "120" }
                        },
                        [_vm._v("付款金额")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-align: right; required",
                          attrs: { width: "150" }
                        },
                        [_vm._v("支付方式")]
                      ),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "100" } }, [_vm._v("操作")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    { staticClass: "body" },
                    _vm._l(_vm.settlePayPhaseInfo.settlePayPhaseList, function(
                      item,
                      index
                    ) {
                      return _c("tr", { staticClass: "row" }, [
                        item.visible
                          ? _c(
                              "td",
                              { attrs: { rowspan: item.rowspan } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "settlePayPhaseList." +
                                        index +
                                        ".phaseName",
                                      rules: {
                                        validator: _vm.checkPhaseName,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "fl",
                                      staticStyle: { width: "80%" },
                                      attrs: { type: "text" },
                                      on: {
                                        blur: function($event) {
                                          _vm.changePhaseName(index)
                                        }
                                      },
                                      model: {
                                        value: item.phaseName,
                                        callback: function($$v) {
                                          _vm.$set(item, "phaseName", $$v)
                                        },
                                        expression: "item.phaseName"
                                      }
                                    }),
                                    _vm._v(" "),
                                    item.rowspan < _vm.payMethodList.length
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "swb-btn-link fr inline-block",
                                            on: {
                                              click: function($event) {
                                                _vm.addPhaseItem(index)
                                              }
                                            }
                                          },
                                          [_vm._v("增加付款次数")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.visible
                          ? _c(
                              "td",
                              { attrs: { rowspan: item.rowspan } },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        on: {
                                          change: function($event) {
                                            _vm.changePhaseType(index)
                                          }
                                        },
                                        model: {
                                          value: item.phaseType,
                                          callback: function($$v) {
                                            _vm.$set(item, "phaseType", $$v)
                                          },
                                          expression: "item.phaseType"
                                        }
                                      },
                                      _vm._l(_vm.phaseTypeList, function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.text,
                                            value: item.value
                                          }
                                        })
                                      })
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.visible
                          ? _c(
                              "td",
                              { attrs: { rowspan: item.rowspan } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "settlePayPhaseList." +
                                        index +
                                        ".acntPeriodStartDate",
                                      rules: {
                                        required: true,
                                        type: "date",
                                        message: "请选择日期",
                                        trigger: "change"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "120px" },
                                      attrs: {
                                        type: "date",
                                        format: "yyyy-MM-dd",
                                        placeholder: "选择日期"
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.changeAcntPeriodStartDate(index)
                                        }
                                      },
                                      model: {
                                        value: item.acntPeriodStartDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "acntPeriodStartDate",
                                            $$v
                                          )
                                        },
                                        expression: "item.acntPeriodStartDate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.settlePayPhaseInfo.acntPeriodForm == 1 &&
                        item.visible
                          ? _c(
                              "td",
                              {
                                staticClass: "text-right",
                                attrs: { rowspan: item.rowspan }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "settlePayPhaseList." +
                                        index +
                                        ".acntPeriodDays",
                                      rules: {
                                        validator: _vm.validateIntNotNull,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      on: {
                                        change: function($event) {
                                          _vm.changeAcntPeriodDays(index)
                                        }
                                      },
                                      model: {
                                        value: item.acntPeriodDays,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "acntPeriodDays",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.acntPeriodDays"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.settlePayPhaseInfo.acntPeriodForm == 2 &&
                        item.visible
                          ? _c(
                              "td",
                              {
                                staticClass: "text-right",
                                attrs: { rowspan: item.rowspan }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "settlePayPhaseList." +
                                        index +
                                        ".phaseGapDays",
                                      rules: {
                                        validator: _vm.validateIntNotNull,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      on: {
                                        change: function($event) {
                                          _vm.changePhaseGapDays(index)
                                        }
                                      },
                                      model: {
                                        value: item.phaseGapDays,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "phaseGapDays",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.phaseGapDays"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: item.calcBasis,
                                      callback: function($$v) {
                                        _vm.$set(item, "calcBasis", $$v)
                                      },
                                      expression: "item.calcBasis"
                                    }
                                  },
                                  _vm._l(_vm.amtCalcMethodList, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.text,
                                        value: item.value
                                      }
                                    })
                                  })
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-right" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "settlePayPhaseList." + index + ".ratio",
                                  rules: {
                                    validator: _vm.validateRatio,
                                    trigger: "blur"
                                  }
                                }
                              },
                              [
                                _c("el-input", {
                                  on: {
                                    blur: function($event) {
                                      _vm.changeRatio(index)
                                    }
                                  },
                                  model: {
                                    value: item.ratio,
                                    callback: function($$v) {
                                      _vm.$set(item, "ratio", $$v)
                                    },
                                    expression: "item.ratio"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("span", [_vm._v(_vm._s(item.amount))])
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: item.payMethod,
                                      callback: function($$v) {
                                        _vm.$set(item, "payMethod", $$v)
                                      },
                                      expression: "item.payMethod"
                                    }
                                  },
                                  _vm._l(_vm.payMethodList, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.text,
                                        value: item.value
                                      }
                                    })
                                  })
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.payPhaseRemoveItem(index)
                                }
                              }
                            },
                            [_c("span", [_vm._v("移除")])]
                          )
                        ])
                      ])
                    })
                  ),
                  _vm._v(" "),
                  _vm.settlePayPhaseInfo.settlePayPhaseList[
                    _vm.settlePayPhaseInfo.settlePayPhaseList.length - 1
                  ] == null ||
                  _vm.settlePayPhaseInfo.settlePayPhaseList[
                    _vm.settlePayPhaseInfo.settlePayPhaseList.length - 1
                  ].phaseType != 9
                    ? _c("tfoot", { staticClass: "foot" }, [
                        _c("tr", { staticClass: "row" }, [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                padding: "10px",
                                border: "1px solid #dfe6ec",
                                "text-align": "center"
                              },
                              attrs: { colspan: "9" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "swb-btn swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.addSettlePayPhase()
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon iconfont icon-jiahao mr5"
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("添加阶段")])
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("基本信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("买家名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("卖家名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供应商标识")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("利润中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("结算描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("付款阶段")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("付款账期形式")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75d3d57e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d3d57e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/receipt/SettleProofPurchReceiptTmp.vue
// module id = 3007
// module chunks = 0